import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, FlexRow, IconButton } from "@similarweb/ui-components";

// Empty-state line shown in a filter card when no conditions are applied yet.
// Relocated from the Technologies filter so every compound/condition filter shares one look.
export const StyledEmptyText = styled.p<{ isHidden: boolean }>`
    ${mixins.setFontVariant("caption", colorsPalettes.bluegrey[600])};
    display: ${({ isHidden }) => (isHidden ? "none" : "block")};
    line-height: normal;
    margin-bottom: 16px;
`;

// Centered "+ Add ..." trigger container. Consolidates the Technologies filter's add-button container and the
// group dialog's add-condition container into a single shared component.
export const StyledAddConditionContainer = styled.div`
    display: flex;
    justify-content: center;
`;

// Centered "AND" separator rendered between stacked condition cards.
export const StyledConditionSeparator = styled.div`
    ${mixins.setFontVariant("captionTitle", colorsPalettes.carbon[300])}
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    margin: 8px 0;
`;

export const StyledConditionCardContainer = styled(FlexColumn)<{ $fullWidth?: boolean }>`
    width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "251px")};
    box-sizing: border-box;
    padding: 4px 8px 8px 8px;
    border-radius: 8px;
    background: ${colorsPalettes.bluegrey[300]};
`;

export const StyledConditionCardHeader = styled(FlexRow)`
    justify-content: space-between;
    margin-bottom: 4px;
    flex-basis: 32px;
`;

export const StyledConditionCardTitle = styled(FlexRow)`
    align-items: center;
`;

export const StyledConditionCardActions = styled(FlexRow)``;

export const StyledConditionCardFieldLabel = styled.div`
    ${mixins.setFontVariant("chip1TopRow", colorsPalettes.carbon[400])}
    margin-bottom: 2px;
`;

export const StyledConditionCardContent = styled(FlexRow)`
    flex-wrap: wrap;
    align-items: baseline;
`;

export const StyledConditionCardText = styled.div`
    ${mixins.setFontVariant("chip1TopRow", colorsPalettes.carbon[500])}
    font-weight: 700;
`;

export const StyledConditionCardValueDivider = styled.div`
    ${mixins.setFontVariant("captionTitle", colorsPalettes.carbon[300])}
    display: flex;
    align-items: center;
    text-transform: uppercase;
    margin: 0 4px;
`;

export const StyledConditionCardIconButton = styled(IconButton)`
    ${SWReactIcons} {
        svg path {
            fill: ${colorsPalettes.midnight[400]};
            fill-opacity: 1;
        }
    }

    &:hover {
        ${SWReactIcons} {
            svg path {
                fill: ${colorsPalettes.midnight[400]};
                fill-opacity: 1;
            }
        }
    }
`;
